import { Enums } from '../common/enums'

import { IOpData } from '../util/interfaces'

import { OpDataType } from '../core/op-data-type'
import { OpDashboard } from '../custom/op-dashboard'


export class OpDashboardData implements IOpData {

    // Properties

    public idDashboardData: number
    public idDashboard: number
    public idDataType: number
    public indexNbr: number
    public value: any

    // Properties end


    // NavigationProperties

    public dashboard: OpDashboard
    public dataType: OpDataType

    // NavigationProperties end


    constructor(opObj: any) {
        this.fromJSON(opObj)
    }


    // IOpChangeState implementation

    public opState: Enums.OpChangeState

    // IOpChangeState implementation end


    // IOpData implementation

    public get idData() { return this.idDashboardData }
    public set idData(idData: number) { this.idDashboardData = idData }

    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    // IOpData implementation end

    public toString() {
        return "DashboardData [" + this.idData + "]"
    }

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.idDashboardData = opObj.IdDashboardData
            this.idDashboard = opObj.IdDashboard
            this.idDataType = opObj.IdDataType
            this.indexNbr = opObj.IndexNbr
            this.value = opObj.Value
            this.opState = opObj.OpState

            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null
        } else {
            this.idDashboardData = 0;
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            IdDashboardData: this.idDashboardData,
            IdDashboard: this.idDashboard,
            IdDataType: this.idDataType,
            IndexNbr: this.indexNbr,
            Value: this.value
        }
    }

    public static fromIOpData(data: IOpData): OpDashboardData {
        const newData: OpDashboardData = new OpDashboardData(null)

        newData.idDashboardData = data.idData,
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }
}